import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import theBG1 from "../../../assets/images/food2.png";
import AboutNav from "./AboutNav";
import { Redirect } from "react-router-dom";
import { CSSTransition } from "react-transition-group";

const useStyles = makeStyles((theme) => ({
  bg: {
    height: "100vh",
    width: "100%",
    backgroundSize: "cover",
  },
}));

export default function About() {
  const classes = useStyles();
  const [img, changeImage] = useState(theBG1);
  const [transition, changeTrans] = useState(true);
  const [color, changeColor] = useState(
    "linear-gradient(270deg, #E7A977, #EBBE9B)"
  );

  const handleTrans = () => {
    changeTrans((prev) => !prev);
  };
  return (
    <Card className={classes.bg}>
      <CSSTransition classNames="fade" timeout={300} in={transition}>
        <CardMedia
          component="img"
          alt="bun-bo-img"
          image={img}
          style={{ width: "100%", height: "100%" }}
        />
      </CSSTransition>
      <Grid
        container
        style={{
          position: "fixed",
          zIndex: 1,
          top: 0,
          height: "100vh",
          display: "flex",
          justifyContent: "flex-end",
          overflow: "auto",
        }}
      >
        <Grid
          item
          style={{
            width: "50rem",
            maxWidth: "50rem",
            background: color,
            backgroundSize: "400% 400%",
            WebkitAnimation: "breath 3s ease infinite",
            MozAnimation: "breath 3s ease infinite",
            animation: "breath 3s ease infinite",
          }}
        >
          <AboutNav
            imageChange={{ changeImage }}
            colorChange={{ changeColor }}
            transChange={{ handleTrans }}
          />
          <Redirect from="/about" to="/about/food" />
        </Grid>
      </Grid>
    </Card>
  );
}
